<template>
    <!-- Asset Type Information Modal -->
    <div class="modal fade" :id="modalId" tabindex="-1" :aria-labelledby="modalLabelId" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-scrollable ">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" :id="modalLabelId">
                        <img v-if="assetType && assetType.icon_class" :src="'/img/icons/avid-icons/' + assetType.icon_class + '.svg'" class="asset-type-icon icon me-2" alt=""></img>
                        {{ assetType ? assetType.name : 'Channel Information' }}
                    </h5>
                    <button type="button" class="btn btn-white float-end close-modal" data-bs-dismiss="modal" aria-label="Close" data-bs-toggle="tooltip" title="Close">
                        <img class="icon" src="/img/icons/avid-icons/close.svg" alt=""> 
                    </button>
                </div>
                <div class="modal-body" v-if="assetType">
                    <div v-if="assetType.explanation" class="mb-2">
                        <div v-html="assetType.explanation"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'AssetTypeInfoModal',
    props: {
        assetType: {
            type: Object,
            default: null
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        modalId() {
            return `assetTypeInfoModal-${this.assetType?.id || 'new'}`;
        },
        modalLabelId() {
            return `assetTypeInfoModalLabel-${this.assetType?.id || 'new'}`;
        }
    },
    watch: {
        show(newVal) {
            if (newVal) {
                this.$nextTick(() => {
                    this.showModal();
                });
            } else {
                this.hideModal();
            }
        }
    },
    emits: ['close'],
    methods: {
        showModal() {
            const modalElement = document.getElementById(this.modalId);
            if (modalElement) {
                const existingModal = window.bootstrap.Modal.getInstance(modalElement);
                if (existingModal) {
                    existingModal.dispose();
                }
                const modal = new window.bootstrap.Modal(modalElement);
                modal.show();
            }
        },
        hideModal() {
            const modalElement = document.getElementById(this.modalId);
            if (modalElement) {
                const modal = window.bootstrap.Modal.getInstance(modalElement);
                if (modal) {
                    modal.hide();
                }
            }
        },
        setupModalEventListeners() {
            const modalElement = document.getElementById(this.modalId);
            if (modalElement) {
                modalElement.addEventListener('hidden.bs.modal', () => {
                    this.$emit('close');
                });
            }
        }
    },
    mounted() {
        this.setupModalEventListeners();
    },
    updated() {
        this.setupModalEventListeners();
    }
});
</script>
